import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/admin/partners")({
  head: () => ({
    meta: [
      { title: "Partner verification · Landoo Admin" },
      { name: "description", content: "Partner verification — Landoo admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Partner verification" role="Admin" items={ADMIN_NAV}>
      <PlaceholderCard
        title="Partner verification"
        description="Admin queue for Partner verification. Actions and filters will be added here."
      />
    </DashboardShell>
  ),
});
